import usePageMeta from "utils/usePageMeta";
// Material Kit 2 React components
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import PostConstruction_Section1 from "./sections/PostConstruction_Section1";
import PostConstruction_Section2 from "./sections/PostConstruction_Section2";
import PostConstruction_Section3 from "./sections/PostConstruction_Section3";
import PostConstruction_Section4 from "./sections/PostConstruction_Section4";

function PostConstructionCleaning() {
  usePageMeta({
    title: "Post Construction Cleaning Ireland | Spechs",
    description:
      "Post-construction and builders clean services across Ireland. Site-ready cleaning after building work.",
    canonical: "https://www.spechs.ie/cleaning/construction/",
  });
  return (
    <SubPageLayout title="Post-Construction Cleaning">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <PostConstruction_Section1 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <PostConstruction_Section2 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <PostConstruction_Section3 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <PostConstruction_Section4 />
      </MKBox>
    </SubPageLayout>
  );
}

export default PostConstructionCleaning;
